module.exports = __webpack_public_path__ + "img/home1.4830eac1.jpg";